export default {
  updateRequestLoadingStatus(state, type) {
    state.isShowRequestLoading = type;
  },
  updateIsEn(state, b) {
    state.isEn = b;
  },
};